import { useCallback, useEffect, useRef } from 'react';
import { UseFileInputOptions } from './use-file-input-options';

type VoidFn = () => void;

type TriggerFn = (...args: any[]) => void;

export const useFileInput = (options: UseFileInputOptions = {}): TriggerFn => {
  const input = useRef<HTMLInputElement>();
  const onChange = useRef<UseFileInputOptions['onChange']>(options.onChange);

  const trigger = useCallback((): void => {
    if (input.current) {
      input.current.click();
    }
  }, []);

  useEffect((): void => {
    onChange.current = options.onChange;
  }, [options.onChange]);

  useEffect(
    (): VoidFn => {
      input.current = document.createElement('input');
      input.current.type = 'file';
      if (options.accept) {
        input.current.accept = options.accept.join(',');
      }
      if (options.multiple) {
        input.current.setAttribute('multiple', 'true');
      }
      if (options.capture) {
        input.current.setAttribute('capture', options.capture);
      }
      input.current.addEventListener('change', (): void => {
        if (onChange.current && input.current && input.current.files) {
          onChange.current(input.current.files);
        }
      });
      return (): void => {
        if (input.current && input.current.parentElement) {
          input.current.parentElement.removeChild(input.current);
        }
      };
    },
  );

  return trigger;
};
